import React from 'react';
import './Resume.css';

function Resume() {
  const education = [
    {
      degree: "B.S. Computational Data Science, Minor in Drones and Robotics",
      school: "New Jersey Institute of Technology",
      year: "Sept 2023 - May 2027",
      gpa: "3.7/4.0"
    },
    {
      degree: "High School Diploma",
      school: "John F. Kennedy Memorial High School",
      year: "Sept 2019 - May 2023",
      gpa: "4.0/4.0"
    }
  ];

  const experience = [
    {
      title: "AI/ML Studio Researcher (Team Lead)",
      company: "Allstate Insurance Company",
      period: "Aug 2025 - Dec 2025",
      responsibilities: [
        "Led a 7-person team building an ML solution to predict claim severity/loss cost from 188K+ auto claims and 132 features.",
        "Created a reproducible preprocessing pipeline in Python (feature engineering, one-hot encoding, log target transformation) and performed EDA/visualization to validate signal and data quality.",
        "Trained and evaluated Linear Regression, XGBoost, and Neural Nets; achieved best results with XGBoost (MAE 0.413 on log(loss), approx. $1.1K MAE) and summarized findings for stakeholders."
      ]
    },
    {
      title: "Machine-Learning Based Cybersecurity Researcher",
      company: "SJSU National Science Foundation REU",
      period: "May 2025 - Aug 2025",
      responsibilities: [
        "Designed and executed secure-AI experiments for IoT network defense as part of a nationally funded NSF REU, owning the workflow from dataset preparation and preprocessing through model training, validation, and error analysis in Python (TensorFlow, Keras, NumPy).",
        "Built and evaluated deep learning attack classification models at scale (1M+ samples), achieving 99% accuracy and reporting results with clear metrics and experiment notes for reproducibility.",
        "Ran synthetic malware/data generation experiments (GANs, diffusion) to expand test coverage and stress-test model robustness under varied attack patterns.",
        "Prototyped an LLM + RAG mitigation pipeline using Hugging Face and FAISS to retrieve attack-relevant context and generate attack-specific mitigations; implemented similarity-based evaluation with 0.94-0.98 cosine similarity matching and documented findings for an in-progress manuscript."
      ]
    }
  ];

  const skills = {
    "Languages": ["Python", "Java", "C++", "C", "JavaScript", "SQL", "MATLAB", "HTML", "CSS"],
    "Developer Tools": ["Git", "Docker", "Jupyter", "Colab"],
    "Data Science & Machine Learning": ["NumPy", "Pandas", "scikit-learn", "Regression", "Classification", "Clustering", "Tree-Based Models", "SVM", "OpenCV"],
    "Deep Learning & NLP": ["PyTorch", "TensorFlow", "Keras", "Hugging Face", "Transformers", "Embeddings", "CNNs", "Text Classification"],
    "CAD & Hardware": ["Arduino", "LocoXtreme", "Fusion 360", "3D Printing", "Circuit Prototyping", "Laser Cutting", "Soldering"],
    "Data / Analytics Tools": ["Excel", "Tableau"]
  };

  return (
    <section id="resume" className="resume-section">
      <div className="resume-container">
        <h2 className="resume-title">Resume</h2>
        
        <div className="resume-content">
          {/* Education Section */}
          <div className="resume-block">
            <h3 className="section-title">Education</h3>
            <div className="timeline">
              {education.map((edu, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-marker"></div>
                  <div className="timeline-content">
                    <h4 className="item-title">{edu.degree}</h4>
                    <p className="item-subtitle">{edu.school}</p>
                    <div className="item-details">
                      <span className="item-period">{edu.year}</span>
                      <span className="item-gpa">GPA: {edu.gpa}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Experience Section */}
          <div className="resume-block">
            <h3 className="section-title">Experience</h3>
            <div className="timeline">
              {experience.map((exp, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-marker"></div>
                  <div className="timeline-content">
                    <h4 className="item-title">{exp.title}</h4>
                    <p className="item-subtitle">{exp.company} ({exp.period})</p>
                    <ul className="responsibilities">
                      {exp.responsibilities.map((resp, respIndex) => (
                        <li key={respIndex}>{resp}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Skills Section */}
          <div className="resume-block">
            <h3 className="section-title">Skills</h3>
            <div className="skills-categories">
              {Object.entries(skills).map(([category, skillList], index) => (
                <div key={index} className="skill-category">
                  <h4 className="category-title">{category}</h4>
                  <div className="skill-list">
                    {skillList.map((skill, skillIndex) => (
                      <span key={skillIndex} className="skill-item">{skill}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;